import { render, staticRenderFns } from "./getimage.vue?vue&type=template&id=a8b76edc&scoped=true&"
import script from "./getimage.vue?vue&type=script&lang=js&"
export * from "./getimage.vue?vue&type=script&lang=js&"
import style0 from "./getimage.vue?vue&type=style&index=0&id=a8b76edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b76edc",
  null
  
)

export default component.exports